
import { LucideIcon } from "lucide-react";

interface SidebarItem {
  id: string;
  label: string;
  icon: LucideIcon;
}

interface DeviceCommandsSidebarProps {
  items: SidebarItem[];
  activeSection: string;
  onSectionChange: (sectionId: string) => void;
}

export const DeviceCommandsSidebar = ({ items, activeSection, onSectionChange }: DeviceCommandsSidebarProps) => {
  return (
    <div className="min-w-fit bg-gray-50 border-r border-gray-200 h-full">
      <div className="p-2">
        <h3 className="text-xs font-medium text-gray-900 mb-2 whitespace-nowrap">Commands</h3>
        <nav className="space-y-0.5">
          {items.map((item) => {
            const Icon = item.icon;
            const isActive = activeSection === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => onSectionChange(item.id)}
                className={`
                  w-full flex items-center px-2 py-1 text-xs font-medium rounded transition-colors whitespace-nowrap
                  ${isActive 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'text-gray-700 hover:bg-gray-100'
                  }
                `}
              >
                <Icon className="w-3 h-3 mr-1.5 flex-shrink-0" />
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};
